/** Build-time configuration. Every value comes from a `VITE_*` environment variable. */
const env = import.meta.env;

const apiBase: string = (env.VITE_API_BASE_URL as string | undefined) ?? '';

export const config = {
  /** Base URL with a single trailing slash, e.g. `https://host/dev/`. */
  apiBaseUrl: apiBase === '' ? '' : apiBase.endsWith('/') ? apiBase : `${apiBase}/`,
  apiHost: (() => {
    try {
      return new URL(apiBase).host;
    } catch {
      return '';
    }
  })(),
  appSyncHttpHost: (env.VITE_APPSYNC_HTTP_HOST as string | undefined) ?? '',
  appSyncRealtimeHost: (env.VITE_APPSYNC_REALTIME_HOST as string | undefined) ?? '',
  environment: (env.VITE_ENVIRONMENT as string | undefined) ?? 'dev',
  firebase: {
    apiKey: (env.VITE_FIREBASE_API_KEY as string | undefined) ?? '',
    authDomain: (env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined) ?? '',
    projectId: (env.VITE_FIREBASE_PROJECT_ID as string | undefined) ?? 'ethrhunt-dev',
    appId: (env.VITE_FIREBASE_APP_ID as string | undefined) ?? '',
  },
  datadog: {
    clientToken: (env.VITE_DATADOG_CLIENT_TOKEN as string | undefined) ?? '',
    applicationId: (env.VITE_DATADOG_APPLICATION_ID as string | undefined) ?? '',
    env: (env.VITE_DATADOG_ENV as string | undefined) ?? 'dev',
    service: 'ethrhunt-client',
  },
};

export const datadogEnabled = config.datadog.clientToken !== '' && config.datadog.applicationId !== '';

/** Resolve an API path (`api/v1/player`) against the base URL. */
export function apiUrl(path: string): string {
  return `${config.apiBaseUrl}${path.startsWith('/') ? path.slice(1) : path}`;
}
